export default __webpack_public_path__ + "static/media/Ofuro_Off_Grid_package.ba7c6e63.jpg";